import { render, staticRenderFns } from "./landingpage.vue?vue&type=template&id=79c9b3b2&scoped=true"
import script from "./landingpage.vue?vue&type=script&lang=js"
export * from "./landingpage.vue?vue&type=script&lang=js"
import style0 from "./landingpage.vue?vue&type=style&index=0&id=79c9b3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c9b3b2",
  null
  
)

export default component.exports